<template>
    <div class="MsgWrap">

        <div class="loading-spinner" v-if="isLoading">
            <base-spinner></base-spinner>
        </div>

        <!-- 항목 테이블 -->
        <div class="tbl_wrap" v-else>

            <div class="counter">
               <div>
                    <base-button-sm mode="btn-white" @click="delMessag('send')">
                        <img src="@/assets/imgs/icon/x.png" > 삭제
                    </base-button-sm>

                </div>
                <div class="search">
                    검색
                </div>
            </div>
            <table class="tbl">
                <colgroup>
                    <col style="width:5%" />
                    <col style="width:15%" />
                    <col style="*" />
                    <col style="width:15%" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <base-checkbox checkvalue="all"  @click="icheck($event)"/>
                        </th>
                        <th>받는이</th>
                        <th>내용</th>
                        <th>발송일</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="messageLists.data.length > 0">
                        <tr v-for="(msg, index) in messageLists.data" :key="index">
                            <td>
                                 <base-checkbox :checkvalue="msg.id"  @click="icheck($event)"/>
                            </td>
                            <td>
                                <span @click="setReceiveUser(msg.receive_user.nic)">
                                    {{msg.receive_user.nic}}
                                </span>
                            </td>
                            <td class="cont"> {{ msg.message }}</td>
                            <td><display-time :time="msg.created_at"/></td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td colspan="4" class="txt-center">보낸 쪽지가 없습니다.</td>
                        </tr>
                    </template>
                </tbody>

            </table>
            <div class="paging">
                <paginate store="message" collection="messages"  @paging="getMessages($event, 'send')"/>
            </div>
        </div>

    </div>
</template>
<script>
import { auth } from '@/components/mixins/auth.js';
import { icheck } from '@/components/mixins/icheck.js';
import { message } from '@/components/mixins/message.js';
import DisplayTime from '@/components/site/parts/DisplayTime.vue';
import Paginate from '@/components/site/parts/PaginatePublic.vue'
import { mapGetters } from 'vuex';

export default {
    name:'message_send'
    ,   
    components:{
        DisplayTime,
        Paginate
    },
    mixins:[ auth,message,icheck ],
    mounted(){
        this.getMessages(this.page, 'send');
        this.listen();
        if(this.userNic)
        {
            this.receive_user_nic.val = this.userNic;
        }
    },
    computed:mapGetters({
        messageLists:'message/getMessages'
    }),
    methods:{

        setReceiveUser(nic)
        {
            this.receive_user_nic.val = nic;
            this.receive_user_nic.isValid = true;
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/ani_slide";
@import '@/assets/scss/table';
@import '@/assets/scss/message';
</style>
